import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-8 w-full min-w-0 rounded-sm border border-foreground bg-background px-2.5 py-1 text-[13px] placeholder:text-ink-3 file:text-foreground selection:bg-primary selection:text-primary-foreground transition-colors disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-foreground aria-invalid:border-brand",
        className
      )}
      {...props}
    />
  )
}

export { Input }
